import { routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { applyMiddleware, createStore, Store, AnyAction, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import { rootReducer, rootSaga } from './store/store';
import environmentSettings from './config/env/index.json';

export default function configureStore(
	history: History
): {
	store: Store<any, AnyAction> & {
		dispatch: {};
	};
} {
	const composeEnhancers = composeWithDevTools({});
	const sagaMiddleware = createSagaMiddleware();

	const isDebugActive = environmentSettings.logger.debug;

	const reducer = rootReducer(history);

	const middleware = [routerMiddleware(history), sagaMiddleware];

	const store = createStore(
		reducer,
		undefined,
		isDebugActive ? composeEnhancers(applyMiddleware(...middleware)) : compose(applyMiddleware(...middleware))
	);

	sagaMiddleware.run(rootSaga);

	return { store };
}
